import { render, staticRenderFns } from "./CollectionPerformance.vue?vue&type=template&id=22c02aa0&scoped=true"
import script from "./CollectionPerformance.vue?vue&type=script&lang=js"
export * from "./CollectionPerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionPerformance.vue?vue&type=style&index=0&id=22c02aa0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c02aa0",
  null
  
)

export default component.exports